import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function FeaturedVideos() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 8);

  return (
    <section className="py-14 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                热门推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">大家都在看的国产好内容</p>
            </div>
            <Link
              to="/category/dianshiju"
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
            >
              查看更多
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 animate-fade-in-up" data-product-shop="">
            {hotVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}